import styled from 'styled-components'
import { Color } from 'root-constants'
import { Button } from 'components/Button'

export const StyledResult = {
  Root: styled.div`
    position: relative;
    padding-bottom: 33px;
    z-index: 2;
  `,
  Title: styled.h1`
    padding: 10px 0 19px;
    font-weight: 700;
    font-size: 28px;
    line-height: 38px;
    text-align: center;
  `,
  Subtitle: styled.h2`
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: ${Color.LIGHT};
  `,
  Separator: styled.div`
    margin: 16px auto 24px;
    max-width: 360px;
    height: 1px;
    background-color: ${Color.LIGHT};
    opacity: 0.5;
  `,
  PersonalSummary: styled.h2`
    padding-bottom: 16px;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
  `,
  Button: styled(Button)`
    margin-top: 0;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
  `,
}
